<div class="stock-footer-wrapper">
  <div class="footer-pagination">
    <div class="stocks-list-wrap">
      <div class="stock-list">Stock List</div>
      <div class="pagination-text">
        <a *ngFor="let letter of alphabet"
           [href]="config.MOJO_STOCK_URL + 'getstocksbyname?n=' + letter + urlHelper.getCidParam(cid, false)">
          {{ letter }}
        </a>
        <a [href]="config.MOJO_STOCK_URL + 'getstocksbyname?n=Other' + urlHelper.getCidParam(cid, false)">
          Other
        </a>
      </div>
    </div>
    <hr />
  </div>
</div>

<div class="container-fluid footer-details">
  <section class="py-4">
    <div class="row footer-text-style">
      <p><b>Name:</b> MOJO Markets Private Limited (Research Entity) (SEBI Registration No. INH000021942) (CIN:U74900MH2015PTC264951)</p>
      <p><b>Registered &amp; Correspondence Address:</b> Benefice Business House, Office No. 3B, 3rd Floor, C.S. 242, Mathuradas Mills Estate, N.M. Joshi Marg, Tulsi Pipe Road, Lower Parel West, Mumbai- 400013</p>
      <p>For queries or grievances, please contact us on <a href="mailto:support.ra@mojomarkets.in">support.ra@mojomarkets.in</a>, Phone : 022-35121239</p>
      <p>"Investments in securities market are subject to market risks. Read all the related documents carefully before investing. Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors."</p>
    </div>
  </section>
</div>

<footer class="text-center text-white">
  <div class="footer-menu-wrapper">
    <div class="footer-menu">
      <ul>
        <li><a [href]="config.MOJO_WEB_URL + 'mojo/privacypolicy'">Privacy Policy</a></li>
        <li><a [href]="config.MOJO_WEB_URL + 'mojo/refundpolicy'">Refund Policy</a></li>
        <li><a [href]="config.MOJO_WEB_URL + 'mojo/disclaimer'">Disclaimers</a></li>
        <li><a [href]="config.MOJO_WEB_URL + 'mojo/termsofuse'">Terms of Use</a></li>
      </ul>
    </div>
    <div>All Rights reserved | © Mojo Markets {{ currentYear }}</div>
  </div>
</footer>

<!-- MOSL - Removed floating share button -->
<!-- <app-share-button></app-share-button> -->
